import { createApi } from "@reduxjs/toolkit/query/react";
import { fetchBaseQueryByAxios } from "@/redux/api/fetchBaseQueryHelper";
import _ from "lodash";

/**
 * https://redux-toolkit.js.org/rtk-query/api/fetchBaseQuery#prepareheaders
 * here to learn more about the query
 * or see
 * `postSlice-example`, `userSlice-example`
 */
export const phoneTemplateApi = createApi({
	reducerPath: "phoneTemplate",
	baseQuery: fetchBaseQueryByAxios,
	endpoints: (builder) => ({
		getTemplates: builder.query({
			query: () => `/template/queryAllTemplates`,
			transformResponse: (responseData) => {
				return responseData.data;
			},
		}),
		getKeywords: builder.query({
			query: () => `/template/queryAllCols`,
			transformResponse: (responseData) => {
				return responseData.data.map((data) => data.templateColName);
			},
		}),
		deleteTemplate: builder.mutation({
			query(id) {
				return {
					url: `/template/deleteTemplate?templateId=${id}`,
					method: "DELETE",
				};
			},
		}),
		addTemplate: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/template/createTemplate",
					method: "POST",
					body: initialPost,
				};
			},
		}),
		updateTemplate: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/template/updateTemplate",
					method: "PUT",
					body: initialPost,
				};
			},
		}),
		sendMessages: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/template/sendMsgByTemplate",
					method: "POST",
					body: initialPost,
				};
			},
		}),
		sendMessage: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/template/sendSingleMsgByTemplate",
					method: "POST",
					body: initialPost,
				};
			},
		}),
		sendCsutomMessage: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/template/sendCustomizeMsg",
					method: "POST",
					body: initialPost,
				};
			},
		}),
		sendMessageWithPhone: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/template/sendMsgByTemplateAndPhone",
					method: "POST",
					body: initialPost,
				};
			},
		}),
		sendMessageWithCusPhoneUpdated: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/template/sendCusMsgBaseOnTemplate",
					method: "POST",
					body: initialPost,
				};
			},
		}),
	}),
});

export const {
	useGetKeywordsQuery,
	useGetTemplatesQuery,
	useGetKeywordssQuery,
	useDeleteTemplateQuery,
	useAddTemplateMutation,
	useDeleteTemplateMutation,
	useUpdateTemplateMutation,
	useSendMessagesMutation,
	useSendMessageMutation,
	useSendCsutomMessageMutation,
	useSendMessageWithPhoneMutation,
	useSendMessageWithCusPhoneUpdatedMutation,
} = phoneTemplateApi;
